import { useState } from 'react'
import { Copy, Check } from 'lucide-react'
import './McpConnectionInfo.css'

function McpConnectionInfo() {
  const [copied, setCopied] = useState(false)

  const baseUrl = window.location.origin
  const mcpUrl = `${baseUrl}/api/mcp`

  // Placeholder — replace with a minted lbak_… UserApiKey from ApiTokenControls above.
  const configSnippet = JSON.stringify(
    {
      mcpServers: {
        'loop-builder': {
          type: 'streamable-http',
          url: mcpUrl,
          headers: {
            Authorization: 'Bearer lbak_your_api_key_here',
          },
        },
      },
    },
    null,
    2,
  )

  const handleCopy = () => {
    navigator.clipboard.writeText(configSnippet)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="mcp-info" data-testid="mcp-connection-info">
      <p className="mcp-info__description">
        Connect an MCP client to explore apps, tasks, and logs on this instance. Authenticate with
        an API key: mint one above, then paste it as{' '}
        <code>Authorization: Bearer lbak_…</code>.
      </p>
      <div className="mcp-info__row">
        <span className="mcp-info__label">Endpoint</span>
        <code className="mcp-info__url" data-testid="mcp-endpoint-url">{mcpUrl}</code>
      </div>
      <div className="mcp-info__config">
        <div className="mcp-info__config-header">
          <span className="mcp-info__label">Client Configuration</span>
          <button className="mcp-info__copy-btn" onClick={handleCopy} data-testid="mcp-copy-config">
            {copied ? <Check size={12} /> : <Copy size={12} />}
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>
        <pre className="mcp-info__config-code" data-testid="mcp-config-snippet">{configSnippet}</pre>
      </div>
      <p className="mcp-info__tools-summary">
        Replace <code>lbak_your_api_key_here</code> with an API key minted above. Plaintext is shown
        only once at mint time.
      </p>
      <p className="mcp-info__tools-summary">
        <strong>Read tools:</strong> list_apps, get_app, list_tasks, get_task_logs, list_containers,
        get_container_logs, list_chats, get_chat_messages, get_activity, list_app_access.
        <br />
        <strong>Auth-gated create:</strong> create_app (any CookiePrincipal / UserApiKey / M2M).
        <br />
        <strong>EditorScoped</strong> (require editor ACL on <code>app_id</code>): start_chat,
        stop_chat, send_chat_message, set_app_privacy, set_app_access,
        list/add/remove_app_allowlist_entry.
      </p>
    </div>
  )
}

export default McpConnectionInfo
